module.exports = __webpack_public_path__ + "img/ff02.7d770421.svg";